import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
const camelToSpaces = (value) => {
    return value === null || value === void 0 ? void 0 : value.replace(/([A-Z])/g, ',$1').replace(/^,/, '').split(',').join(' ');
};
const GendersRadioGroup = ({ gender, genders, onChange }) => {
    return (_jsx(RadioGroup, Object.assign({ value: gender, onChange: onChange }, { children: genders.map((g) => (_jsx(FormControlLabel, { value: g.gender, sx: { marginLeft: (theme) => theme.spacing(1) }, control: _jsx(Radio, { color: "primary" }), label: camelToSpaces(g.description) }, g.gender))) })));
};
export default GendersRadioGroup;
//# sourceMappingURL=index.js.map